import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getBlogPostById } from "../../methods/blog/blogRequests";
import WebsiteLayout from "../../layouts/website";
import { CardMedia, Container, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

const BlogPost = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch blog post
  const getBlogPost = async (id) => {
    try {
      const response = await getBlogPostById(id);
      if (response.success) {
        setBlog(response.data);
      } else {
        setBlog(null);
      }
    } catch (error) {
      throw error(error);
    } finally {
      setLoading(false); // Ensure loading is set to false in all cases
    }
  };
  
  useEffect(() => {
    getBlogPost(id);
  }, [id]);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!blog) {
    return <p>Blog post not found.</p>;
  }

  return (
    <div>
      <WebsiteLayout>
        <Container
          maxWidth="lg"
          component="main"
          sx={{ display: "flex", flexDirection: "column", my: 16, gap: 4 }}
        >
          <Grid container spacing={2}>
            <Grid>
              <div>
                <CardMedia
                  component="img"
                  alt="blog image"
                  image={blog.image_url}
                  sx={{
                    height: { sm: "auto", md: "50%" },
                    aspectRatio: { sm: "16 / 9", md: "" },
                  }}
                />
              </div>
              <div>
                <Typography variant="h1" gutterBottom>
                  {blog.title}
                </Typography>
                <Typography variant="h5" gutterBottom>
                  Author: {blog.user.name}
                </Typography>
                <Typography variant="h5" gutterBottom>
                  Published On: {blog.created_at}
                </Typography>
              </div>
              <div dangerouslySetInnerHTML={{ __html: blog.blog_post }}></div>
            </Grid>
          </Grid>
        </Container>
      </WebsiteLayout>
    </div>
  );
};

export default BlogPost;
